{
    "AppMenu_AppsTitle": "Menu",
    "AppMenu_Apps_Reporting": "Analytique",
    "AppMenu_Apps_FastProvisioning": "Provisionnement rapide",
    "AppMenu_Apps_Administration": "Administration",
    "AppMenu_Apps_StatusAndTools": "Statut et outils",
    "AppMenu_FavouritesTitle": "Favoris",
    "NAME": "AppMenu"
}